module.exports = __webpack_public_path__ + "bc18aff41d710133cbc2f31118d4ddf4.png";